class ProductCardUpsell extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", (event) => {
      this.handleSubmit(event);
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.submitter.disabled = true;
    const formData = new FormData(this.form);
    const response = await fetch(window.Shopify.routes.cart_add_url, {
      method: "POST",
      body: formData,
    });
    const { sections } = await response.json();
    for (const [key, value] of Object.entries(sections)) {
      document.querySelector(`#${key}`).innerHTML =
        new DOMParser().parseFromString(
          value,
          "text/html",
        ).body.firstChild.innerHTML;
    }
    event.submitter.disabled = false;
  }
}

customElements.define("product-card-upsell", ProductCardUpsell);
